import LINKS from "@/lib/links";
import { Component } from "@builder.io/sdk";

export const buildRewardingCareerConfig: Component = {
  name: "Build Rewarding Career (Home)",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Build a Rewarding Career",
    },
    {
      name: "subheading",
      type: "longText",
      defaultValue:
        "Join one of Bay Area's 50 Best Places to work in aging services.",
    },
    {
      name: "overrideLogos",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "logos",
      type: "list",
      showIf: "options.get('overrideLogos') === true",
      onChange: (options) => {
        if (options.get("logos").length > 2) {
          options.set("logos", options.get("logos").slice(0, 2));
          alert("Maximum logos item is 2");
        }
      },
      defaultValue: [],
      subFields: [
        {
          name: "src",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
        },
        {
          name: "alt",
          type: "string",
        },
      ],
    },
    {
      name: "overrideImages",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "images",
      type: "list",
      showIf: "options.get('overrideImages') === true",
      onChange: (options) => {
        if (options.get("images").length > 3) {
          options.set("images", options.get("images").slice(0, 3));
          alert("Maximum images item is 3");
        }
      },
      defaultValue: [],
      subFields: [
        {
          name: "src",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
        },
        {
          name: "alt",
          type: "string",
        },
      ],
    },
    {
      name: "primaryCta",
      type: "object",
      defaultValue: {
        text: "Search Jobs",
        href: LINKS.careers.href,
        ariaLabel: "Search Jobs",
      },
      subFields: [
        {
          name: "text",
          type: "string",
        },
        {
          name: "href",
          type: "string",
        },
        {
          name: "ariaLabel",
          type: "string",
        },
      ],
    },
  ],
};
